module.exports = __webpack_public_path__ + "img/estimate.49723946.jpg";